import styled from 'styled-components';

export const Container = styled.div<{ headerHeight: string }>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: calc(100vh - ${(props) => props.headerHeight});
`;
